import { useEffect, useState } from 'react';
import { Platform, Pressable, Text, View } from 'react-native';
import { colors } from '../theme';

/** Only relevant for the web build (PWA) — shows install instructions right
 * inside the app itself, since the browser's "Add to Home Screen" action
 * saves whatever page is on screen at that moment. Doing this on the
 * marketing landing page instead of here was the original bug: iOS ended up
 * pinning the landing page (no icon, wrong content) instead of the app. */
export function InstallBanner() {
  const [dismissed, setDismissed] = useState(false);
  const [platform, setPlatform] = useState<'ios' | 'android' | null>(null);
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);

  useEffect(() => {
    if (Platform.OS !== 'web' || typeof window === 'undefined') return;

    const isStandalone =
      window.matchMedia?.('(display-mode: standalone)').matches ||
      (window.navigator as any).standalone === true;
    if (isStandalone) return;

    const ua = window.navigator.userAgent;
    if (/iphone|ipad|ipod/i.test(ua)) {
      setPlatform('ios');
    } else if (/android/i.test(ua)) {
      setPlatform('android');
    }

    const onBeforeInstall = (e: any) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', onBeforeInstall);
    return () => window.removeEventListener('beforeinstallprompt', onBeforeInstall);
  }, []);

  if (Platform.OS !== 'web' || dismissed || !platform) return null;

  const onAndroidInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setDismissed(true);
  };

  return (
    <View
      style={{
        backgroundColor: colors.primary,
        borderRadius: 12,
        padding: 14,
        marginBottom: 20,
      }}
    >
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Text style={{ color: '#fff', fontWeight: '700', fontSize: 14, flex: 1 }}>
          📲 Cài Loot vào màn hình chính
        </Text>
        <Pressable onPress={() => setDismissed(true)} hitSlop={8}>
          <Text style={{ color: '#fff', fontSize: 16, opacity: 0.85 }}>✕</Text>
        </Pressable>
      </View>

      {platform === 'ios' ? (
        <Text style={{ color: '#fff', fontSize: 12.5, marginTop: 8, lineHeight: 18 }}>
          Bấm biểu tượng Chia sẻ <Text style={{ fontWeight: '700' }}>⬆️</Text> ở thanh dưới cùng của
          Safari, chọn <Text style={{ fontWeight: '700' }}>"Thêm vào MH chính"</Text>, rồi bấm{' '}
          <Text style={{ fontWeight: '700' }}>"Thêm"</Text>.
        </Text>
      ) : deferredPrompt ? (
        <Pressable
          onPress={onAndroidInstall}
          style={{
            marginTop: 10,
            backgroundColor: '#fff',
            borderRadius: 8,
            paddingVertical: 8,
            alignItems: 'center',
          }}
        >
          <Text style={{ color: colors.primary, fontWeight: '700', fontSize: 13 }}>Cài đặt ngay</Text>
        </Pressable>
      ) : (
        <Text style={{ color: '#fff', fontSize: 12.5, marginTop: 8, lineHeight: 18 }}>
          Bấm menu <Text style={{ fontWeight: '700' }}>⋮</Text> góc trên bên phải trình duyệt, chọn{' '}
          <Text style={{ fontWeight: '700' }}>"Cài đặt ứng dụng"</Text> hoặc{' '}
          <Text style={{ fontWeight: '700' }}>"Thêm vào Màn hình chính"</Text>.
        </Text>
      )}
    </View>
  );
}
